import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setSortBy } from '../store/slices/filtersSlice';
import { selectAllProperties, selectPropertiesLoading } from '../store/selectors/propertySelectors';
import { sortProperties } from '../utils/propertyHelpers';
import { useTranslation } from '../utils/translations';
import PropertyCard from '../components/PropertyCard/PropertyCard';
import { SkeletonList, FadeIn } from '../components/loading';
import './PropertiesPage.css';

const PropertiesPage = () => {
  const dispatch = useDispatch();
  const allProperties = useSelector(selectAllProperties);
  const loading = useSelector(selectPropertiesLoading);
  const filters = useSelector((state) => state.filters);
  const { t } = useTranslation();

  const sortedProperties = sortProperties(allProperties, filters.sortBy);
  const showSkeleton = loading && allProperties.length === 0;

  return (
    <div className="properties-page">
      <div className="container">
        <div className="page-header">
          <h1>{t('propertyList.availableProperties')}</h1>
          <p>{t('propertyList.subtitle') || 'Browse all available properties'}</p>
        </div>

        <div className="section-header">
          <div className="sort-controls">
            <label>{t('propertyList.sortBy')}</label>
            <select
              value={filters.sortBy}
              onChange={(e) => dispatch(setSortBy(e.target.value))}
            >
              <option value="newest">{t('propertyList.newest')}</option>
              <option value="price-low">{t('propertyList.priceLow')}</option>
              <option value="price-high">{t('propertyList.priceHigh')}</option>
            </select>
          </div>
        </div>

        {showSkeleton ? (
          <SkeletonList count={9} />
        ) : sortedProperties.length > 0 ? (
          <div className="property-grid">
            {sortedProperties.map((property, index) => (
              <FadeIn key={property.id} delay={Math.min(index * 0.03, 0.24)}>
                <PropertyCard property={property} />
              </FadeIn>
            ))}
          </div>
        ) : (
          <div className="no-properties">
            <p>{t('propertyList.noPropertiesFound')}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PropertiesPage;
